import { FastshiftDashboardPage } from "@/pages/dashboard/fastshift-dashboard-page";

import { init } from "../init";

// Use fastshift-portal's custom init function
init(FastshiftDashboardPage);
